export default __webpack_public_path__ + "static/media/etapa7.c937c413.png";